import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";

interface StatusData {
  name: string;
  value: number;
  color: string;
}

const estadoFitossanitario: StatusData[] = [
  { name: "Bom", value: 8234, color: "#1B6E4F" },
  { name: "Regular", value: 2856, color: "#F57C00" },
  { name: "Ruim", value: 893, color: "#D32F2F" },
  { name: "Crítico", value: 347, color: "#8D1F1F" },
  { name: "Morta", value: 156, color: "#3F4A52" },
];

const riscoData: StatusData[] = [
  { name: "Baixo", value: 7134, color: "#1B6E4F" },
  { name: "Médio", value: 3845, color: "#FBC02D" },
  { name: "Alto", value: 1420, color: "#F57C00" },
  { name: "Crítico", value: 87, color: "#D32F2F" },
];

export function FitossanitarioChart() {
  return (
    <div className="bg-white rounded-card border border-background-200 p-5">
      <h3 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">Estado Fitossanitário</h3>
      <div className="h-[220px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={estadoFitossanitario}
              cx="50%"
              cy="50%"
              innerRadius={48}
              outerRadius={80}
              paddingAngle={2}
              dataKey="value"
            >
              {estadoFitossanitario.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number) => value.toLocaleString("pt-BR")}
              contentStyle={{
                borderRadius: "8px",
                border: "1px solid #E8EAED",
                fontSize: "12px",
              }}
            />
            <Legend
              iconType="circle"
              iconSize={8}
              formatter={(value: string) => (
                <span className="text-xs text-foreground-600">{value}</span>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export function RiscoChart() {
  return (
    <div className="bg-white rounded-card border border-background-200 p-5">
      <h3 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">Classificação de Risco</h3>
      <div className="h-[220px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={riscoData}
              cx="50%"
              cy="50%"
              innerRadius={48}
              outerRadius={80}
              paddingAngle={2}
              dataKey="value"
            >
              {riscoData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number) => value.toLocaleString("pt-BR")}
              contentStyle={{
                borderRadius: "8px",
                border: "1px solid #E8EAED",
                fontSize: "12px",
              }}
            />
            <Legend
              iconType="circle"
              iconSize={8}
              formatter={(value: string) => (
                <span className="text-xs text-foreground-600">{value}</span>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}